import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import {I18nextProvider} from "react-i18next";
import App from './App';
import reportWebVitals from './reportWebVitals';
import common_en from "./locales/en/common.json";
import common_fr from "./locales/fr/common.json";
import i18next from "i18next";

i18next.init({
  interpolation: { escapeValue: false },  // React already does escaping
  lng: 'fr',                              // default language to use
  resources: {
    en: {
      common: common_en
    },
    fr: {
      common: common_fr
    },
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App/>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
